import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";
import { APICALL } from "../api/api";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    setErr(null);
    if (form.checkValidity()) {
      const params = { email: email };
      try {
        setLoading(true);
        const res = await APICALL("/user/sendPasswordResetOtp", "post", params);
        console.log("res", res);
        if (res?.status === 200) {
          navigate("/otp-verify", { state: email });
        } else {
          setErr(res?.message || "Something went wrong.");
        }
      } catch (err) {
        setErr(err?.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <section className="login_page">
        <Container>
          <Row className="justify-content-center">
            <Col md={6}>
              <div className="login-card">
                <div className="text-center mb-4">
                  <div className="ai-icon mb-3">
                    <i class="fa-solid fa-envelope"></i>
                  </div>
                  <h1 className="login-title">Forgot Password</h1>
                  <p className="text-white">
                    Enter Your Email Address To reset Your Password
                  </p>
                </div>

                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="email">
                      <Mail size={16} className="me-2" />
                      Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="form-control-dark"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid email address.
                    </Form.Control.Feedback>
                  </Form.Group>

                  {err && (
                    <p className="text-danger">
                      <strong> {err}</strong>
                    </p>
                  )}
                  <Button
                    type="submit"
                    className="btn-gradient w-100 mb-3"
                    size="lg"
                  >
                    {loading ? "Loading..." : " Get OTP"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ForgotPassword;
